import React, { useState, useEffect } from 'react';
import './RefundPolicy.css';
import DynamicBanner from '../../Pages/include/DynamicBanner';
import api from '../../../api';

const RefundPolicy = () => {
    const [refundData, setRefundData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchRefundData = async () => {
            try {
                const response = await api.get("/api/sitepages/academic/campus-life");
                const data = response.data;

                if (data.status && data.data) {
                    const refundPage = data.data.find(page => page.page_slug === "refund");
                    
                    if (refundPage) {
                        // Clean the image URLs before setting the data
                        const cleanedRefundPage = cleanImageUrls(refundPage);
                        setRefundData(cleanedRefundPage);
                    } else {
                        throw new Error("Refund policy page not found");
                    }
                } else {
                    throw new Error("Invalid data structure");
                }
                
                setIsLoading(false);

            } catch (err) {
                console.error("Error fetching Refund Policy data:", err);
                setError("Failed to load Refund Policy data");
                setIsLoading(false);
            }
        };

        fetchRefundData();
    }, []);


    const cleanImageUrls = (data) => {
        if (!data.banner?.images) return data;
        
        const cleanedImages = data.banner.images.map(img => {
            if (!img) return img;
  
            if (img.includes('/public/')) {
                const parts = img.split('/public');
                // parts[1] will be "/storage/campus_life/..."
                return parts[1];
            }
            
 
            return img;
        });

        return {
            ...data,
            banner: {
                ...data.banner,
                images: cleanedImages
            }
        };
    };

    if (isLoading) {
        return (
            <div className="refundpolicy-page">
                <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2">Loading Refund Policy...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="refundpolicy-page">
                <div className="alert alert-danger text-center m-4" role="alert">
                    Error loading Refund Policy: {error}
                </div>
            </div>
        );
    }

    if (!refundData) {
        return (
            <div className="refundpolicy-page">
                <div className="alert alert-warning text-center m-4" role="alert">
                    No Refund Policy data available at the moment.
                </div>
            </div>
        );
    }

    // Extract API Data
    const bannerData = refundData.banner || {};
    const contentData = refundData.content || {};

    const bannerTitle = bannerData.title || "Refund Policy";
    const bannerImages = bannerData.images || [];
       const mobileeImages = bannerData.mobile_images || [];
    const pageHeading = contentData.heading || "Refund Policy";
    const refundItems = contentData.items || [];

    return (
        <div className="refundpolicy-page">
            {/* Dynamic Banner */}
            {bannerImages.length > 0 && (
                <DynamicBanner
                    title={bannerTitle}
                    bgImage={bannerImages} bgImageMobile={mobileeImages}
                />
            )}

            {/* Refund Policy Content Section */}
            <section className="refundpolicy">
                <div className="container">
                    <div className="row mb-5">
                        <div className="col-md-12">
                            <div className="res-content">
                                <div className="sec-title text-center">
                                    <h2>{pageHeading}</h2>
                                </div>

                                <div className="row">
                                    {refundItems.length > 0 ? (
                                        <ul className="admission-list">
                                            {refundItems.map((item, index) => (
                                                <li key={index}>
                                                    <i className="fa fa-check-circle-o"></i> 
                                                    <strong>{item.heading}:</strong> {item.text}
                                                </li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <div className="text-center">
                                            <p>No refund policy available.</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default RefundPolicy;